import { NgIf } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';

import { I18NextModule } from 'angular-i18next';

import { ButtonModule, HrModule, MessageModule, SvgIconModule } from '@hdms/shared/ui-core';

@Component({
  selector: 'mt-ui-error',
  standalone: true,
  imports: [NgIf, MessageModule, I18NextModule, HrModule, SvgIconModule, ButtonModule],
  templateUrl: './error.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ErrorComponent {
  readonly errorI18nKey = `general.error.endpoint.`;
}
